<template>
  <div class="fixed inset-x-0 bottom-3 z-[1020] text-center">
    <a
      class="ya-te-fixed-button co-btn-counseling co-display-12 mx-auto w-60 rounded-full !bg-[#225cff] font-bold hover:opacity-80 lg:w-[16.125rem]"
      href="#schedule"
      @click.prevent="scrollTo('schedule')"
    >
      まずは相談してみる（無料）
    </a>
  </div>
</template>

<script setup lang="ts">
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

if (import.meta.client) {
  gsap.registerPlugin(ScrollTrigger)
}

const fixedButton = () => {
  ScrollTrigger.create({
    // .ya-te-fixed-button-startより下にスクロールしたら表示
    // .ya-te-fixed-button-startより上にスクロールしたら非表示
    // #scheduleまでスクロールしたら非表示
    trigger: '.ya-te-fixed-button-start',
    start: 'top center',
    toggleActions: 'none none none none',
    endTrigger: '#schedule',
    end: 'top +=100%',
    toggleClass: {
      targets: '.ya-te-fixed-button',
      className: 'active',
    },
    markers: false, // 本番環境で使うときはfalseにする
  })
}

onMounted(() => {
  fixedButton()
})

</script>

<style scoped>
.ya-te-fixed-button {
  display: none;
}

.ya-te-fixed-button.active {
  display: block;
  animation-name: fade-in;
  animation-duration: 0.5s;
  animation-fill-mode: forwards;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
